<template>
  <nav class="navigation">
    <div class="nav-brand">
      <img src="@/assets/logo.png" alt="Prec8" class="logo" />
    </div>
    <div class="nav-menu">
      <router-link v-if="isAdmin" to="/admin" class="nav-item" @click="onAdminClick">Admin</router-link>
      <router-link to="/dashboard" class="nav-item">Home</router-link>
      <router-link to="/leaderboard" class="nav-item">Leaderboard</router-link>
      <router-link to="/rewards" class="nav-item">Rewards Store</router-link>
      <router-link to="/how-it-works" class="nav-item">How it works</router-link>
      <v-menu>
        <template v-slot:activator="{ props }">
          <v-btn
            v-bind="props"
            variant="text"
            class="nav-item user-menu-btn"
          >
            <div class="user-info">
              <div class="user-name">{{ userName }}</div>
              <div v-if="userHandle" class="user-handle">@{{ userHandle }}</div>
            </div>
            <v-icon icon="mdi-chevron-down" class="ml-1" />
          </v-btn>
        </template>
        <v-list>
          <v-list-item to="/my-redemptions">
            <v-list-item-title>
              <v-icon icon="mdi-history" class="mr-2" />
              My Redemptions
            </v-list-item-title>
          </v-list-item>
          <v-list-item @click="signOut">
            <v-list-item-title>
              <v-icon icon="mdi-logout" class="mr-2" />
              Sign Out
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
  </nav>
</template>

<script setup lang="ts">
import { ref, onMounted, computed } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '../stores/authStore'
import { analytics } from '../services/analytics'

const router = useRouter()
const { checkAuth, clearAuth } = useAuthStore()

const isAdmin = ref(false)
const userName = ref('')
const userHandle = ref('')
const userRole = ref('')

onMounted(async () => {
  try {
    // Use the auth store to get user info (with caching)
    const authData = await checkAuth()
    userName.value = authData.userName || 'User'
    userHandle.value = authData.userHandle || ''
    userRole.value = authData.role || ''
    isAdmin.value = authData.isAdmin || authData.role === 'Admin'
    console.log('Navigation: Auth data:', authData)
    console.log('Navigation: Is admin?', isAdmin.value)
    console.log('Navigation: Role:', authData.role)
  } catch (error) {
    console.error('Error checking auth status:', error)
  }
})

const onAdminClick = () => {
  console.log('🔐 Admin link clicked!')
  console.log('🔐 Current isAdmin value:', isAdmin.value)
  console.log('🔐 Current userRole value:', userRole.value)
  analytics.trackButtonClick('Admin Link', 'Navigation')
}

const signOut = async () => {
  try {
    try {
      await fetch(`${process.env.VUE_APP_API_BASE_URL}/logout`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Accept': 'application/json'
        }
      })
    } catch (error) {
      console.warn('Server logout failed, falling back to client-side:', error)
    }

    // Clear the auth store
    clearAuth()

    document.cookie = 'session_token=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; Domain=.ngrok-free.app; Secure; SameSite=None'
    document.cookie = 'session_token=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; Secure; SameSite=None'
    
    router.push('/sign-in')
          analytics.trackAuth('sign_out')
  } catch (error) {
    console.error('Error signing out:', error)
  }
}
</script>

<style scoped>
.navigation {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2rem;
  background-color: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  border-bottom: 1px solid #e1e5e9;
}

.nav-brand {
  font-size: 1.5rem;
  font-weight: bold;
  color: #333;
  display: flex;
  align-items: center;
}

.logo {
  height: 40px;
  width: auto;
  object-fit: contain;
}

.nav-menu {
  display: flex;
  gap: 1.5rem;
  align-items: center;
}

.nav-item {
  text-decoration: none;
  color: #666;
  font-weight: 500;
  transition: color 0.2s;
}

.nav-item:hover {
  color: #333;
}

.nav-item.router-link-active {
  color: #333;
  font-weight: 600;
}

.user-menu-btn {
  text-transform: none !important;
  letter-spacing: normal !important;
}

.user-info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
}

.user-name {
  font-weight: 500;
  color: #333;
  line-height: 1.2;
}

.user-handle {
  font-size: 0.75rem;
  color: #666;
  font-weight: 400;
  line-height: 1.2;
}
</style>
